import type { ReactNode } from 'react';

import type { MoneySection } from '@/lib/orgNav';

export const MONEY_SECTION_TITLES: Record<MoneySection, string> = {
  spend: 'Spend',
  plan: 'Plan & billing',
  credits: 'Credits',
};

/** One part of the Money page under its own heading; its id is the `/money#…` anchor. */
export function OrgMoneySection({
  id,
  description,
  actions,
  children,
}: {
  id: MoneySection;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section id={id} aria-labelledby={`${id}-heading`} className="scroll-mt-20">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3 border-b border-border pb-3">
        <div className="min-w-0 space-y-1">
          <h2 id={`${id}-heading`} className="text-lg font-semibold tracking-tight text-foreground">
            {MONEY_SECTION_TITLES[id]}
          </h2>
          {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
      {children}
    </section>
  );
}
